import React, { createContext, useContext, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const StoreContext = createContext<string | null>(null);
export const useStoreId = () => useContext(StoreContext);

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [storeId, setStoreId] = useState<string | null>(null);

  useEffect(() => {
    try {
      const userData = localStorage.getItem('userData');
      if (userData) {
        const parsed = JSON.parse(userData);
        setIsAuthenticated(!!parsed?.isAuthenticated);
        const storeIds = parsed?.userDetails?.storeIds;
        setStoreId(Array.isArray(storeIds) && storeIds.length > 0 ? storeIds[0] : null);
      } else {
        setIsAuthenticated(false);
      }
    } catch (err) {
      console.error('Error parsing localStorage:', err);
      setIsAuthenticated(false);
    } finally {
      setLoading(false);
    }
  }, []);

  if (loading) return null; // or a loader spinner

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return <StoreContext.Provider value={storeId}>{children}</StoreContext.Provider>;
};

export default ProtectedRoute;
